import PubSub from 'pubsub-js';

const $window = $(window);

const $itemTitle = $('.content__itemTitle');

PubSub.subscribe('scroll', () => {
  const scrollTop = $window.scrollTop();
  $itemTitle.each((_index, element) => {
    const top = $(element).offset().top;
    if (top < scrollTop) {
      $(element).addClass('-hide');
    } else {
      $(element).removeClass('-hide');
    }
  });
});
